// extracted by mini-css-extract-plugin
export default {"container":"R95cooFW_NyRcoOle0BH","headline":"oa0zakyzqM4ORdyQ9Xip"};